import React from 'react'
import { Row, Col, Table, Button, Form, Card, Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartShopping, faTrash } from '@fortawesome/free-solid-svg-icons'
import AddShipping from '../AddShipping.js'
import { formatCurrency } from '../../utils/cart.js'

const PosReceiptCard = ({
  theme,
  cartItems,
  totals,
  taxrate,
  onDelete,
  onShippingChange,
  onCancelSale,
  showCheckout,
  onOpenCheckout,
  onCloseCheckout,
  onSaveCheckout,
  qrid,
  onQridChange
}) => (
  <Card
    className='h-100 pos-receipt-card'
    style={{
      backgroundColor: theme.card,
      color: theme.text,
      borderColor: theme.sidebarAccent
    }}
  >
    <Card.Header
      style={{
        backgroundColor: theme.surfaceMuted,
        borderColor: theme.sidebarAccent
      }}
    >
      <div className='d-flex align-items-center justify-content-between'>
        <h4 className='mb-0' style={{ color: theme.text }}>
          Current sale
        </h4>
        <span className='pos-cart-count'>
          <FontAwesomeIcon icon={faCartShopping} aria-hidden='true' />{' '}
          {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}
        </span>
      </div>
    </Card.Header>
    <Card.Body>
      <Table
        striped
        bordered
        hover
        responsive='md'
        className='mb-0 table-sm pos-receipt-table'
      >
        <colgroup>
          <col style={{ width: '18%' }} />
          <col style={{ width: '18%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '16%' }} />
          <col style={{ width: '12%' }} />
          <col style={{ width: '18%' }} />
          <col style={{ width: '8%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>Mfg</th>
            <th>Name</th>
            <th>Qty</th>
            <th>Per</th>
            <th>Disc</th>
            <th>Price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {cartItems.length > 0 ?
            cartItems.map((saleitem) => (
              <tr key={saleitem.id}>
                <td>{saleitem.manufacturer}</td>
                <td>{saleitem.subname}</td>
                <td align='center'>{saleitem.quantity}</td>
                <td align='right'>{formatCurrency(saleitem.price)}</td>
                <td align='right'>{saleitem.itemdiscount}%</td>
                <td align='right'>{formatCurrency(saleitem.lineSubtotal)}</td>
                <td>
                  <Button
                    type='button'
                    variant='danger'
                    size='sm'
                    aria-label={`Remove ${saleitem.subname} from sale`}
                    onClick={() => onDelete(saleitem.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </td>
              </tr>
            ))
          : <tr>
              <td colSpan='7' className='text-center'>
                Add products from the list to build this sale.
              </td>
            </tr>
          }
        </tbody>
      </Table>
    </Card.Body>
    <Card.Footer>
      <Row>
        <Col>Subtotal</Col>
        <Col align='right'>{formatCurrency(totals.subtotal)}</Col>
      </Row>
      <Row>
        <Col>Disc on sale</Col>
        <Col align='right'>- {formatCurrency(totals.discount)}</Col>
      </Row>
      <Row>
        <Col>
          <AddShipping childToparent={onShippingChange} />
          <hr className='solid' />
        </Col>
        <Col align='right'>{formatCurrency(totals.shipping)}</Col>
      </Row>
      <Row>
        <Col>Tax</Col>
        <Col align='right'>
          {formatCurrency(totals.taxes)} @ {taxrate}%
        </Col>
      </Row>
      <Row className='pos-total-row align-items-center'>
        <Col>
          <strong>Total</strong>
          <small className='d-block'>Including tax and shipping</small>
        </Col>
        <Col className='text-end'>
          <strong className='pos-total-amount'>
            {formatCurrency(totals.total)}
          </strong>
        </Col>
      </Row>
      <div className='pos-receipt-actions'>
        {cartItems.length > 0 && (
          <Button
            className='pos-checkout-button w-100'
            size='lg'
            onClick={onOpenCheckout}
          >
            Continue to checkout
          </Button>
        )}
        <Modal show={showCheckout} onHide={onCloseCheckout}>
          <Modal.Header closeButton>
            <Modal.Title>Complete sale</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className='pos-modal-total'>
              Total due <strong>{formatCurrency(totals.total)}</strong>
            </p>

            <Form.Group controlId='qrid'>
              <Form.Label>Receipt QR code (optional)</Form.Label>
              <Form.Control
                autoFocus
                type='text'
                placeholder='Scan or enter a QR code'
                value={qrid}
                onChange={(e) => onQridChange(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='danger' onClick={onCloseCheckout}>
              Cancel
            </Button>
            <Button variant='primary' onClick={onSaveCheckout}>
              Complete sale
            </Button>
          </Modal.Footer>
        </Modal>
        <Button
          type='button'
          variant='outline-danger'
          size='sm'
          onClick={onCancelSale}
        >
          Cancel sale
        </Button>
      </div>
    </Card.Footer>
  </Card>
)

export default PosReceiptCard
